module.exports = "/assets/1b32abe2a2779450a22edd826688133e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/ZU.png
// module id = 771
// module chunks = 0